<span class="status-chip" [class]="cssClass()">{{ value() }}</span>
